/**
 * La liste d'attente de la caisse (décisions 171, 173, 175, 178), derrière
 * `FONCTION_FILE_CAISSE` : l'accueil envoie un non-couvert avec la prestation
 * demandée ; la caissière le « prend », choisit la ligne du tarif (étranger
 * ou non) et encaisse.
 */
import { z } from 'zod';
import { schemaRecu } from './caisse.js';
import { schemaEnregistrementVisite } from './visites.js';
export const STATUTS_ATTENTE_CAISSE = [
    'A_LA_CAISSE',
    'PRISE',
    'ENCAISSEE',
    'PARTI',
    'ANNULE',
];
const schemaQui = schemaRecu.shape.caissiere;
const instant = z.iso.datetime();
export const schemaAttenteCaisse = z.object({
    id: z.uuid(),
    siteId: z.uuid(),
    personne: schemaRecu.shape.patient,
    prestation: z.string(),
    /** Le jour du comptoir à Madagascar, `AAAA-MM-JJ`. */
    jour: z.string(),
    /** L'heure d'arrivée du patient (décision 175) : l'ordre de la liste, puis sa place dans la file. */
    arriveeLe: instant,
    envoyeeLe: instant,
    envoyeePar: schemaQui,
    statut: z.enum(STATUTS_ATTENTE_CAISSE),
    prisePar: schemaQui.nullable(),
    priseLe: instant.nullable(),
    /** « Déjà servi » confirmé par l'accueil à l'envoi : le passage qu'il a vu. */
    confirmeDejaServi: z.uuid().nullable(),
    /**
     * AJ-04 — fiche à confirmer envoyée par « Faire payer (sans attendre la
     * chargée) » : la caisse l'encaisse sur toute ligne de la grille ; sa fiche reste à confirmer.
     */
    sansAttendreLaChargee: z.boolean(),
    encaissementId: z.uuid().nullable(),
    visiteId: z.uuid().nullable(),
    closeLe: instant.nullable(),
    motif: z.string().nullable(),
});
/** R5, R13 — l'envoi porte ce que l'entrée qui suivra le paiement reprendra. */
export const schemaEnvoiCaisse = schemaEnregistrementVisite
    .pick({
    prestation: true,
    reposMedicalJours: true,
    assistanceMaternelle: true,
    observation: true,
    confirmeDejaServi: true,
})
    .extend({
    /**
     * AJ-04 (décision du TL, 28/10) — le geste explicite de l'accueil pour une
     * fiche à confirmer : il paie comme un client externe, sans attendre la
     * chargée. Absent, une fiche à confirmer reste refusée.
     */
    sansAttendreLaChargee: z.literal(true).optional(),
});
/** R15 — « Parti sans payer » : un motif libre, facultatif. */
export const schemaDepartAttente = z
    .object({ motif: z.string().trim().max(300).optional() })
    .strict();
/** L'attente ouverte d'une fiche aujourd'hui (bandeau de la fiche à l'accueil), ou aucune. */
export const schemaAttenteDeFiche = z.object({ attente: schemaAttenteCaisse.nullable() });
//# sourceMappingURL=attente-caisse.js.map